module.exports = __webpack_public_path__ + "static/media/slide1.1b093551.jpg";